import styled from 'foundations-theming/utils';
import { BREAKPOINTS } from 'unsubscribe-ui/constants';
const breakpointMaps = {
  xs: BREAKPOINTS.mobile,
  sm: BREAKPOINTS.tablet,
  md: BREAKPOINTS.desktop,
  lg: BREAKPOINTS.desktopL,
  xl: BREAKPOINTS.desktopXL
};
export const Grid = styled.div.withConfig({
  displayName: "Grid"
})(["display:grid;grid-template-columns:repeat(12,1fr);width:100%;"]);
export const GridItem = styled.div.withConfig({
  displayName: "Grid__GridItem"
})(["", ""], ({
  size,
  alignItems,
  justifyContent,
  textAlign
}) => {
  if (!size) return '';
  return Object.entries(size).map(([breakpoint, columns]) => {
    const breakpointValue = breakpointMaps[breakpoint];
    if (!breakpointValue) return '';
    return `
        align-items: ${alignItems};
        justify-items: ${justifyContent};
        text-align: ${textAlign};
        @media (min-width: ${breakpointValue}) {
          grid-column: span ${columns};
        }
      `;
  }).join('');
});